import Map from '~/javascripts/components/User/ProfileMap/Map';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { useState } from 'react';

const ViewMap = observer(({ accessToken }) => {
  const [isOpen, setOpen] = useState(false);

  const toggleMapStyle = (view) => {
    store.projectDetailsMap.activeMapView = view;
    store.projectDetailsMap.setMapStyle();
  };

  return (
    <>
      <div
        className={cx('map-wrapper', {
          inactive: !store.projectDetailsMap.displayMap,
        })}
      >
        <div
          className={cx('layer-toggle-btn', {
            open: isOpen,
          })}
          onClick={() => setOpen(!isOpen)}
        >
          <div className='layer-options'>
            <label className='layer-opt-wrapper' htmlFor='default'>
              Default
              <input
                checked={store.projectDetailsMap.activeMapView == 'terrain'}
                id='default'
                name='mapStyle'
                onChange={() => toggleMapStyle('terrain')}
                type='radio'
                value='default'
              />
              <span className='checkmark default' />
            </label>
            <label className='layer-opt-wrapper' htmlFor='satellite'>
              Sat
              <input
                checked={store.projectDetailsMap.activeMapView == 'satellite'}
                id='satellite'
                name='mapStyle'
                onChange={() => toggleMapStyle('satellite')}
                type='radio'
                value='satellite'
              />
              <span className='checkmark satellite' />
            </label>
          </div>
        </div>
        {!window.disableMap && store.projectDetailsMap.displayMap && (
          <Map accessToken={accessToken} />
        )}
      </div>
    </>
  );
});

export default ViewMap;
